import { LeafygreenIconProps } from "../../types";

export const SetupFailure: React.ComponentType<LeafygreenIconProps> = ({
  className,
  fill,
  size = 16,
}) => (
  <svg
    aria-label="Setup failure Icon"
    className={className}
    fill="currentColor"
    height={size}
    viewBox="0 0 28 28"
    width={size}
  >
    <path
      d="M26.2 22L17.34 13.16C17.2842 13.1067 17.2182 13.0651 17.1461 13.0377C17.074 13.0102 16.9971 12.9974 16.92 13C16.8425 12.9935 16.7645 13.0046 16.6918 13.0323C16.6191 13.06 16.5536 13.1036 16.5 13.16L16 13.58L13.54 16.12L13.12 16.54V16.68C13.0438 16.7807 13.0025 16.9036 13.0025 17.03C13.0025 17.1563 13.0438 17.2792 13.12 17.38L22 26.24C22.267 26.5405 22.592 26.7838 22.9555 26.9554C23.319 27.127 23.7134 27.2233 24.1151 27.2385C24.5168 27.2537 24.9173 27.1875 25.2927 27.0438C25.6681 26.9001 26.0106 26.682 26.2995 26.4025C26.5884 26.1231 26.8178 25.7881 26.9739 25.4176C27.1299 25.0472 27.2095 24.6491 27.2076 24.2471C27.2058 23.8451 27.1227 23.4477 26.9633 23.0787C26.8039 22.7097 26.5714 22.3768 26.28 22.1L26.2 22Z"
      fill={fill}
    />
    <path
      d="M3.7 5.12L12.62 14.28L13.52 13.38L14.54 12.36L4.82 3.82L5.68 2.96L2.34 0.439998L0.360001 2.54L2.9 5.92L3.7 5.12Z"
      fill={fill}
    />
    <path
      d="M11.34 15.7L9.64 14L1.22 22.42C0.64183 22.9982 0.317017 23.7823 0.317017 24.6C0.317017 25.4177 0.64183 26.2018 1.22 26.78C1.79817 27.3582 2.58234 27.683 3.4 27.683C4.21766 27.683 5.00183 27.3582 5.58 26.78L12.66 19.7L11.74 18.76C11.3436 18.3664 11.0892 17.8523 11.0168 17.2984C10.9444 16.7445 11.0581 16.1822 11.34 15.7Z"
      fill={fill}
    />
    <path
      d="M14.14 9.49999L16 11.26C16.3274 11.1121 16.6809 11.0305 17.04 11.02C17.3711 11.0183 17.6991 11.0829 18.0048 11.21C18.3106 11.3371 18.5877 11.5241 18.82 11.76L20.86 14C21.193 14.0199 21.527 14.0199 21.86 14C23.6375 13.7331 25.2371 12.7733 26.309 11.3304C27.3808 9.88747 27.8378 8.07887 27.58 6.29999C27.5678 6.18762 27.524 6.08099 27.4538 5.99239C27.3836 5.90379 27.2898 5.83682 27.1832 5.7992C27.0766 5.76157 26.9616 5.75483 26.8513 5.77974C26.7411 5.80465 26.6401 5.8602 26.56 5.93999L23.64 8.71999L20.2 7.79999L19.28 4.35999L22.18 1.43999C22.2735 1.3478 22.3363 1.22911 22.36 1.09999C22.3712 1.0211 22.3666 0.940757 22.3465 0.863657C22.3263 0.786557 22.291 0.714245 22.2426 0.650942C22.1942 0.587639 22.1337 0.534614 22.0645 0.494961C21.9954 0.455309 21.9191 0.429824 21.84 0.419994C20.6965 0.259678 19.531 0.392335 18.4527 0.805531C17.3745 1.21873 16.4188 1.89893 15.6752 2.78239C14.9317 3.66585 14.4246 4.72364 14.2016 5.85661C13.9785 6.98957 14.0468 8.16062 14.4 9.25999L14.14 9.49999Z"
      fill={fill}
    />
  </svg>
);
